import { SequenceMenu, SequenceMenuDivider } from '@sequencehq/core-components'
import { useSetAtom } from 'jotai'
import { deletePhaseAtom } from '../../atoms/reviewPricing.atoms'
import { isEditingPhaseNameAtom } from './PhaseLabel'
import { usePhase } from '../../utils/usePhase'

export const PhaseKebabMenu = (props: { phaseId: string }) => {
  const { phase, updatePhase } = usePhase(props.phaseId)
  const deletePhase = useSetAtom(deletePhaseAtom)
  const setIsEditingPhaseName = useSetAtom(isEditingPhaseNameAtom)

  return (
    <SequenceMenu
      data-testid={`reviewPricing.phase.${props.phaseId}.menu`}
      variant="ghost"
      buttonSize="small"
      alignment="bottom-right"
      items={[
        ({ setIsOpen }) => (
          <SequenceMenu.Item
            data-testid={`reviewPricing.phase.${props.phaseId}.menu.${phase.name ? 'editName' : 'addName'}`}
            key="addName"
            uuid="add-name"
            label={phase.name ? 'Edit name' : 'Add name'}
            onClick={() => {
              setIsEditingPhaseName(true)
              setIsOpen?.(false)
            }}
          />
        ),
        ...(phase.name
          ? [
              ({ setIsOpen }: { setIsOpen?: (open: boolean) => void }) => (
                <SequenceMenu.Item
                  data-testid={`reviewPricing.phase.${props.phaseId}.menu.deleteName`}
                  key="deleteName"
                  uuid="delete-name"
                  label="Delete name"
                  onClick={() => {
                    updatePhase({ name: '' })
                    setIsOpen?.(false)
                  }}
                  destructive
                />
              )
            ]
          : []),
        <SequenceMenuDivider key="divider" />,
        ({ setIsOpen }) => (
          <SequenceMenu.Item
            data-testid={`reviewPricing.phase.${props.phaseId}.menu.deletePhase`}
            key="deletePhase"
            uuid="delete-phase"
            label="Remove phase"
            onClick={() => {
              deletePhase(props.phaseId)
              setIsOpen?.(false)
            }}
            destructive
          />
        )
      ]}
    />
  )
}
